"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var IframeManager_1 = __importDefault(require("../../../utilities/IframeManager"));
var exceptions_1 = require("@ikea-aoa/exceptions");
/**
 * This class is used for fetching authentication data.
 */
var OneWebAuthenticationService = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.endpoint Endpoint.
     */
    function OneWebAuthenticationService(options) {
        this.endpoint = null;
        this.endpoint = options.endpoint;
    }
    /**
     * Authenticates and returns token.
     *
     * @returns Promise.
     */
    OneWebAuthenticationService.prototype.getToken = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var iframeManager = new IframeManager_1.default(_this.endpoint);
            var onTokens = function (error, tokens) {
                iframeManager.disconnect();
                if (error) {
                    reject(new exceptions_1.ServiceException('Failed to retrieve token from iframe. Error: ' + error));
                }
                else {
                    var token = tokens.auth ? tokens.auth : tokens.guest;
                    resolve({
                        value: token.value,
                        isGuest: !tokens.auth
                    });
                }
            };
            iframeManager
                .getIframe()
                .then(function (iframe) {
                var ikea = iframe.contentWindow['ikea'];
                if (ikea && ikea.authentication && ikea.authentication.getTokens) {
                    ikea.authentication.getTokens(onTokens);
                }
                else {
                    reject(new exceptions_1.ServiceException('Failed to retrieve token from iframe. "ikea.authentication.getTokens()" is not defined.'));
                }
            })
                .catch(reject);
        });
    };
    return OneWebAuthenticationService;
}());
exports.default = OneWebAuthenticationService;
//# sourceMappingURL=OneWebAuthenticationService.js.map